export default __webpack_public_path__ + "static/media/image.fcf54cd6.png";